import { Component } from '@angular/core';
import { faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ColorNames, ColorShades, DoughnutDataModel, GroupedBarChartDataModel, GroupedBarChartOptions, Notification, TooltipOptions } from 'marketpro-design-lib';
import { SpendingDistribution } from '../../main/models/spending-distribution.model';
import { TableRegion } from '../../main/models/table-region.model';

@Component({
  selector: 'mpro-sample',
  templateUrl: './sample-app.component.html',
  styleUrls: ['./sample-app.component.scss']
})
export class SampleAppComponent {

  faSortUp = faSortUp

  selected: { [key: string]: boolean } = {
    Africa: false,
    Asia: false,
    Australia: false
  }

  inputValue: string = ""
  inputValue2: string = ""
  checked: { checked: boolean, indeterminate: boolean } = { checked: true, indeterminate: true }

  public text: string = 'app text';

  onChange() {
    this.inputValue2 = this.getInputValue()
  }

  getInputValue() {
    let res = ""
    for (const opt in this.selected) {
      if (this.selected[opt]) {
        res += opt + ", "
      }
    }
    return res.slice(0, res.length - 2)
  }

  public notifications: Notification[] = [
    {
      title: "Notification",
      text: "Notification Text",
      button: "Click Me",
      dismiss: true,
      time: -1,
      color: "blue",
      dark: false,
      maxWidth: "none"
    },
    {
      title: "Notification",
      text: "This is a notification which attempts to show that a max width can be useful so the notification isn't the width of the entire screen.",
      button: "Click Me",
      dismiss: true,
      time: 100,
      color: "blue",
      dark: false,
      maxWidth: "250px"
    },
    {
      title: "Notification",
      text: "Notification Text",
      button: "Click Me",
      dismiss: true,
      time: -1,
      color: "apricot",
      dark: false,
      maxWidth: "none"
    },
    {
      title: "Notification",
      text: "Notification Text",
      button: "Click Me",
      dismiss: true,
      time: 100,
      color: "apricot",
      dark: false,
      maxWidth: "none"
    },
  ]

  public chartTooltip: TooltipOptions = {
    type: "chart",
    title: "Chart Tooltip",
    chartDescription: "This is used on charts",
    chartText: "Here is the main information",
    chartCaption: "Caption information",
  }
  public mapTooltip: TooltipOptions = {
    type: "map",
    title: "THAILAND",
    dailySpending: 23.14,
    people: 69000000,
    peopleCaption: 0.002,
    spending: 1620000,
    spendingCaption: 0.004,
    growth: 2.3
  }
  public interactiveTooltip: TooltipOptions = {
    type: "interactive",
    title: "Interactive Tooltip",
    interactiveText: "This explains what is going on",
    interactiveLeft: "Go Back",
    interactiveRight: "Next"
  }
  public simpleTooltip: TooltipOptions = {
    type: "simple",
    title: "Simple Tooltip",
    simpleText: "This is a simple toolitp which is the default"
  }

  public doughnutData: DoughnutDataModel[] = [
    {
      id: 'abc',
      value: 30
    },
    {
      value: 25
    },
    {
      value: 45
    },
    {
      value: 45
    }
  ];

  public doughnutData2: DoughnutDataModel[] = [
    {
      value: 52,
      color: '#329988'
    },
    {
      value: 48,
      color: '#F5B0D9'
    }
  ]


  public groupedBarData: GroupedBarChartDataModel[] = [
    { group: "0-15", bars: [{ key: 'female', value: 16 }, { key: 'male', value: 17 }] },
    { group: "15-30", bars: [{ key: 'female', value: 6 }, { key: 'male', value: 7 }] },
    { group: "30-45", bars: [{ key: 'female', value: 18 }, { key: 'male', value: 19 }] },
    { group: "45-65", bars: [{ key: 'female', value: 11 }, { key: 'male', value: 15 }] },
    { group: "65+", bars: [{ key: 'female', value: 1 }, { key: 'male', value: 2 }] }
  ];

  public chartData: GroupedBarChartDataModel[] = this.groupedBarData;
  public options: GroupedBarChartOptions = {
    colors: [
      { name: ColorNames.Teal, shade: ColorShades.Shade300 },
      { name: ColorNames.Fuchsia, shade: ColorShades.Shade400 }
    ],
    dataAxisStep: 5
  };

  groups = ["0-15", "15-30", "30-45", "45-65", "65+"];
  public randomizeBarData() {
    this.groupedBarData = [];
    this.groups.forEach(g => {
      this.groupedBarData.push({
        group: g,
        bars: [
          { key: 'male', value: this.getRandomArbitrary() },
          { key: 'female', value: this.getRandomArbitrary() },
        ]
      });
    });

    this.chartData = this.groupedBarData;
  }

  // between 1 and 25
  private getRandomArbitrary() {
    return Math.floor(Math.random() * 25) + 1;
  }

  public clickData: any;

  public setSelected(val: any) {
    this.options = { ...this.options, selectedSubgroup: val === 'reset' ? undefined : val };
  }

  public countries: TableRegion[] = [
    { name: "United States of America", people: 333864256.416, spending_ppp: 185740000000, spending_share: 100, growthUntilSelected: 0, growthToEndYear: 1.77, code: 'a' },
    { name: "China", people: 141358477, spending_ppp: 36870000000, spending_share: 100, growthUntilSelected: 0, growthToEndYear: 1.61, code: 'b' },
    { name: "Japan", people: 1368576353, spending_ppp: 27700000000, spending_share: 100, growthUntilSelected: 0, growthToEndYear: 5.83, code: 'c' },
    { name: "Germany", people: 81423734, spending_ppp: 115890000000, spending_share: 100, growthUntilSelected: 0, growthToEndYear: 1.95, code: 'd' },
    { name: "Brazil", people: 219532789, spending_ppp: 7000000000, spending_share: 100, growthUntilSelected: 13, growthToEndYear: -1.10, code: 'e' },
  ]

  public checkedCountries: Set<string> = new Set();
  public disabled = new Set(['Germany'])
  public selectedCountry: string;
  public checkedChange(c: TableRegion) {
    if (this.checkedCountries.has(c.name)) {
      this.checkedCountries.delete(c.name);
    } else {
      this.checkedCountries.add(c.name);
    }
  }

  public sdData: SpendingDistribution[] = [
    { spending_daily: '110', people: 230350000, spending_ppp: 440400000, spending_share: 23.7, id: 1 },
    { spending_daily: '50-110', people: 410340000, spending_ppp: 11470000000, spending_share: 13, id: 2 },
    { spending_daily: '11-50', people: 1163640000, spending_ppp: 24160000000, spending_share: 11.5, id: 3 },
    { spending_daily: '<11', people: 3979140000, spending_ppp: 15420000000, spending_share: 9.5, id: 4 }
  ];
  public total = { spending_daily: 'Total', people: 5783470000, spending_ppp: 190000000000, spending_share: 100, id: 0 }
  public selectedSD: string;
}
